import React from 'react';
import { Paper, Typography, Grid, Card, CardContent, Button, Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService';

export default function PracticesPage() {
  const navigate = useNavigate();
  
  const { data: practices = [], isLoading } = useQuery({
    queryKey: ['practices-all'],
    queryFn: () => apiService.getPracticeDetails('')
  });

  const formatTitle = (str: string) => 
    str.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

  if (isLoading) {
    return <Typography>Loading practices...</Typography>;
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Legal Practices
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Select a practice area to view available workflows
      </Typography>
      
      <Grid container spacing={3}>
        {practices.map((practice: any) => (
          <Grid item xs={12} sm={6} md={4} key={practice.id}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" gutterBottom>
                  {formatTitle(practice.name)}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {practice.workflows?.length || 0} workflows available
                </Typography>
                <Button 
                  variant="contained" 
                  fullWidth
                  onClick={() => navigate(`/${practice.id}`)}
                >
                  View Workflows
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}